export const HEADER_HEIGHT = '64px'
export const LEFT_DRAWER_WIDTH = '240px'
export const RIGHT_DRAWER_WIDTH = '390px'
export const BOTTOM_BAR_HEIGHT = '75px'
